import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-6 py-3" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "w-10/12 px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_4 = { class: "w-10/12 px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_5 = { class: "text-center" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import PageLoader from '@/components/PageLoader.vue';
import PagePagination from '@/components/PagePagination.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import throttle from "lodash/throttle";

import Packages from '@/classes/Packages';
import { useRouter } from 'vue-router';
import { onMounted, ref, watch, computed } from 'vue';

/**
 * ********************************
 * Data 
 * ********************************
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router    = useRouter();
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);

/**
 * ********************************
 * query 
 * ********************************
 */
const searchText = ref();
const activeTab  = ref();
const goToPage   = ref();

// Page Renderer Data
const items       = ref(null);
const items_count = ref(0);
const query       = ref(null);

const hasPermission = computed<boolean>( () => window.$hasPermission('view-packages') || window.$hasPermission('upload-pdf-file') || window.$hasPermission('update-package-and-rider-schedule'));

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'Active',
        count: items_count.value,
        href: '/contents/packages',
        allowed: true
    },
    {
        name: 'Activity Logs',
        count: items_count.value,
        href: '',
        allowed: true
    }
];

const headers: { text: string }[] = [
    { text: 'Package' },
    { text: 'Type' },
    { text: 'Date Created' },
];

/**
 * ********************************
 * Methods 
 * ********************************
 */
const searchData = (val: string) => {
    searchText.value = val
}

const indexPackages = async (data: string) => {
    try {
        loader.value = true;

        const pageNum     = data?.match(/\d+/)?.[0] ?? '1';
        const queryString = searchText.value ? `&query=${searchText.value}` : '';
        const goToPage    = data ? `page=${pageNum}` : 'page=1';

        const response = await Packages.indexPackages(goToPage + queryString);

        loader.value      = false;
        items.value       = response.data;
        items_count.value = response.data.total;
        query.value       = response.data.query;

    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err.response?.data?.message ?? 'An error occurred';
    }
};

/**
 * ********************************
 * Wathchers 
 * ********************************
 */
watch(
      searchText,
      throttle(() => {
        indexPackages(goToPage.value)
      }, 1000)
    );

onMounted(() => indexPackages(goToPage.value))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Packages" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, {
          tabs: tabs,
          "button-items": true
        })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FilterComponent, {
          search: searchText.value,
          onFetchData: searchData,
          "onUpdate:filters": indexPackages,
          modelValue: searchText.value,
          "custom-filters": activeTab.value !== 'activity_logs'
        }, null, 8, ["search", "modelValue", "custom-filters"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DataTable, {
          headers: headers,
          count: items.value?.total
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [
                _createElementVNode("td", _hoisted_3, _toDisplayString(item.name), 1),
                _createElementVNode("td", _hoisted_4, _toDisplayString(item.type), 1),
                _cache[0] || (_cache[0] = _createElementVNode("td", { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }, " Jan 19, 2023 (00:00:00) ", -1)),
                _createElementVNode("td", _hoisted_5, [
                  (hasPermission.value)
                    ? (_openBlock(), _createBlock(ActionButton, {
                        key: 0,
                        "edit-btn": "",
                        onClick: ($event: any) => (_unref(router).push('/contents/packages/show/' + item.name ))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"]),
        _createVNode(PagePagination, {
          class: "mb-6",
          items: items.value,
          onNextPage: indexPackages
        }, null, 8, ["items"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})